import { useEffect, useContext } from "react";

import { LayoutContext } from "../layout/";

import CategoryProduct from "./category-product";

export default function PreInvoice({ }) {
    const { setPageTitle } = useContext(LayoutContext);

    useEffect(() => {
        setPageTitle('پیش فاکتور');
    }, []);

    return (
        <CategoryProduct />
    );
}